import React from 'react';
import { connect } from 'react-redux';

import ResponsesManager from '../../../Shared/components/responses/responsesManager';
import { ActionTypes } from '../../actions/actionTypes';
import * as filterActions from '../../actions/filters';
import * as massEdit from '../../actions/massEdit';
import * as questionActions from '../../actions/questions';
import { deleteResponse, getGradedResponsesWithCallback, submitResponseEdit } from '../../actions/responses';
import { rematchAll, rematchOne } from '../../libs/grading/rematching.ts';

function GrammarResponsesManager(props) {
  return (
    <ResponsesManager
      {...props}
      Constants={ActionTypes}
      deleteResponse={deleteResponse}
      filterActions={filterActions}
      getGradedResponsesWithCallback={getGradedResponsesWithCallback}
      massEditActions={massEdit}
      questionActions={questionActions}
      rematchAll={rematchAll}
      rematchOne={rematchOne}
      storeResponsesLocally={false}
      submitResponseEdit={submitResponseEdit}
    />
  );
}

function select(state) {
  return {
    conceptsFeedback: state.conceptsFeedback,
    concepts: state.concepts,
    filters: state.filters,
    massEdit: state.massEdit,
  };
}

export default connect(select)(GrammarResponsesManager);
